import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { Observable } from 'rxjs';
import { GlobalsConstants } from '../commons/global-constants';
import { SessionService } from './session.service';

@Injectable({providedIn: 'root'})

export class NormaService {

    constructor(private http: HttpClient, private router: Router, private _constants: GlobalsConstants, private session: SessionService) { }

    API_URI = this._constants.API_address + "Normatividad"
    //API_URI = this._constants.API_address + "Normatividad\\FormatodenovedadesdeusuariosTransmisinFDIRecaudoprima_V4.docx"

    fileExportarNorma() {
        return this.http.post(`${this.API_URI}/NovedadUsuario`, null)
    }

    FormatoCreacionUsuario() {
        return this.API_URI;
    }

}
